import { Component, EventEmitter, Inject, Output } from '@angular/core'
import { MatCard } from '@angular/material/card'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogClose,
} from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'

@Component({
  selector: 'dialog-to-choose-unique-new',
  imports: [MatCard, MatDialogClose, MatIcon, MatButton, MatProgressSpinner],
  templateUrl: './dialog-to-choose-unique-new.component.html',
  styleUrl: './dialog-to-choose-unique-new.component.scss',
})
export class DialogChooseUniqueNewComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  @Output() responseTariff = new EventEmitter()

  response(value: boolean) {
    this.responseTariff.emit(value)
  }
}
